export default "__VITE_ASSET__I1i4WHFb__"